import axios from 'axios'
import { ENV, APPKEY, REST } from '../config'
import router from '@/layout/router/index.js'
import { getMatchedModule, getSubModuleName } from '@/layout/router/remote/index.js'
import { getToken } from './token'
import { md5Http } from './common'

export const report = (data) => {
  let token = getToken()
  let now = Date.now()
  axios({
    method: 'post',
    url: `${REST}?syslog.frontendOperationLog.save`,
    data,
    headers: {
      format: 'JSON',
      method: 'syslog.frontendOperationLog.save',
      appkey: APPKEY['syslog'],
      token,
      timestamp: now,
      sign: md5Http(token, now, data)
    }
  })
}
const ua = window.navigator.userAgent
const version = (document.cookie && document.cookie.includes('gray=1') ? 'gray-' : '') + document.lastModified

// 获取组件tag
const vueComponentTag = (vm) => {
  return (vm && vm.$vnode && vm.$vnode.componentOptions && vm.$vnode.componentOptions.tag) || ''
}

// apm自定义上报错误信息
const apmReportFromVue = (err, vm, info) => {
  try {
    const moduleName = getSubModuleName(router.currentRoute)
    const packName = getMatchedModule(moduleName)
    err.message = `【System】:${packName.name}, 【Vue-component】:${vueComponentTag(vm)}, 【info】: ${info}, 【message】:` + err.message
    window._apm && window._apm('captureException', err)
  } catch (error) {
    console.log(error)
  }
}

const install = (Vue) => {
  // 非生产环境Vue错误钩子处理: 上报【apm】、【打印错误】
  if (ENV !== 'prd') {
    Vue.config.errorHandler = (err, vm, info) => {
      // 友盟apm错误信息采集
      apmReportFromVue(err, vm, info)
      throw err
    }
    return
  }
  // 生产环境Vue错误钩子处理: 上报【apm】、【自定义错误上报】
  Vue.config.errorHandler = (err, vm, info) => {
    try {
      // 友盟apm错误信息采集
      apmReportFromVue(err, vm, info)
      // 自定义错误上报
      let user = window.__ERPUSER__ || {}
      let menu = window.__ERPMODULE__ || {}
      report({
        userId: user.id,
        userName: user.name,
        menuId: menu.id,
        menuName: menu.$title,
        error: err.stack,
        option: JSON.stringify({
          version,
          url: decodeURIComponent(location.hash),
          ua,
          info,
          component: vueComponentTag(vm)
        })
      })
      throw err
    } catch (e) {
      throw e
    }
  }
}

export default install



// WEBPACK FOOTER //
// ./src/public/utils/error-handler.js